import React from 'react'
import 'styles/searchByBlock.scss'

const TypeWiseBlock = ({ blockName, arrLinks }) => {
  return (
    <div className="popular_sites col-sm-4">
      <div className="bottom_nav_head">{blockName}</div>
      <ul className="nav">
        {arrLinks
          .filter(value => value.subtype === 'link')
          .map(link => (
            <li key={link.id}>
              <a href={`${link.link}`}>{link.anchortag}</a>
            </li>
          ))}
      </ul>
      {arrLinks
        .filter(value => value.subtype === 'morelink')
        .map(link => (
          <div key={link.id}>
            <a
              href={`${link.link}`}
              className="link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.anchortag}
            </a>
            <span className="rightArrow" />
          </div>
        ))}
    </div>
  )
}

const RenderLinksBlock = ({ linksData }) =>
  Object.keys(linksData).map(key => {
    const arrData = linksData[key]
    return (
      <TypeWiseBlock
        blockName={arrData[0]['type']}
        arrLinks={arrData}
        key={Math.random()}
      />
    )
  })

function SearchByBlock(props) {
  const reOrderedData = (props.searchByData || []).reduce(
    (orderByData, value) => ({
      ...orderByData,
      [value.data.orderby]: [
        ...(orderByData[value.data.orderby] || []),
        value.data,
      ],
    }),
    {}
  )
  return (
    <div className="container">
      <h1 className="text-center find_someone">
        Search by Popular Matchmaking Sites
      </h1>
      <div className="row">
        <RenderLinksBlock linksData={reOrderedData} />
      </div>
    </div>
  )
}

export default SearchByBlock
